/**
 * Created by lowdev on 1/4/18.
 *
 * Fetch JS Doc : https://developer.mozilla.org/fr/docs/Web/API/Fetch_API/Using_Fetch
 * @example : https://github.com/mdn/fetch-examples/
 *
 * @class StaffService
 * @example
 var config = {
         api: {
            staff: {
              detail: '/url/details/<id>'
              list: '/url/details/'
            }
         }
     }
 var service = new StaffService(config);
 service.get().then((success => {
            console.log(success);
     }))
 * @returns {Promise}
 */

import * as Cookies from 'js-cookie'
import Staff from '@pro/models/Staff'

const CSRFToken = Cookies.get('csrftoken')

class Service {
  constructor (config, key) {
    this.api = config.api[key]
    this.headers = {
      'X-CSRFToken': CSRFToken,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }

  get (id) {
    return new Promise((resolve, reject) => {
      fetch(this.api.details.replace('<id>', String(id)), {
        method: 'GET',
        credentials: 'include',
        headers: this.headers
      }).then((response) => {
        if (response.status !== 200) {
          // Not success
          resolve(response.json())
        } else {
          // success
          resolve(response.json().then(data => new Staff(data.id, data.user, data.url)))
        }
      }).catch(err => {
        // Service Error
        reject(err)
      })
    })
  }

  remove (id) {
    return new Promise((resolve, reject) => {
      fetch(this.api.details.replace('<id>', String(id)), {
        method: 'DELETE',
        credentials: 'include',
        headers: this.headers
      }).then((response) => {
        if (response.status !== 200) {
          // Not success
          resolve(response)
        } else {
          // success
          resolve(response)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  getList () {
    return new Promise((resolve, reject) => {
      fetch(this.api.list, {
        method: 'GET',
        credentials: 'include',
        headers: this.headers
      }).then((response) => {
        if (response.status !== 200) {
          // Not success
          response.json()
        } else {
          // success
          resolve(response.json().then(data => data.map((item) => new Staff(item.id, item.user, item.url))))
        }
      }).catch(err => {
        // Service Error
        reject(err)
      })
    })
  }
}

export default Service



// WEBPACK FOOTER //
// ./accounts/pro/static/js/services/Service.js